"use strict";var r=require("styled-components").css`
    display: grid;
    grid-row-gap: 20px;

    > * {
        margin: 0;
    }
`;module.exports=r;
//# sourceMappingURL=styles.js.map
